import { GuardedDeletionService } from 'projects/orchestrator/src/lib/services/guarded-deletion.service';
import { Component, inject } from '@angular/core';
import { OfficialPlannedPlantationPlanningOrchestratorService, OfficialPlannedPlantationProjectionPlanningOrchestratorService } from 'orchestrator';
import { ListService } from '@abp/ng.core';
import {
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  OfficialPlannedPlantationCreateDto,
  OfficialPlannedPlantationUpdateDto,
} from '../proxy/operational/dtos/official-planned-plantation';
import { OFFICIALPLANNEDPLANTATION_CONFIG, OFFICIALPLANNEDPLANTATION_FIELDS } from './official-planned-plantation.config';
import { BaseHierarchicalCrudComponent, GenericForm, ZnHierarchicalViewComponent } from '@zendra/shared';
import { CommonModule } from '@angular/common';
import {
  GetOfficialPlannedPlantationProjectionListInputDto,
  OfficialPlannedPlantationProjectionDto,
  OfficialPlannedPlantationProjectionExcelDownloadDto,
} from 'projects/orchestrator/src/lib/proxy/upm/zendra/cms/projection/official-planned-plantations/models';

@Component({
  selector: 'app-official-planned-plantation',
  imports: [CommonModule, GenericForm, ZnHierarchicalViewComponent],
  providers: [ListService, ConfirmationService],
  templateUrl: './official-planned-plantation.html',
  styleUrl: './official-planned-plantation.scss',
})
export class OfficialPlannedPlantation extends BaseHierarchicalCrudComponent<
  OfficialPlannedPlantationProjectionDto,
  OfficialPlannedPlantationCreateDto,
  OfficialPlannedPlantationUpdateDto,
  OfficialPlannedPlantationProjectionExcelDownloadDto
> {
  private readonly guardedDeletion = inject(GuardedDeletionService);
  private readonly planningOrchestratorService = inject(OfficialPlannedPlantationPlanningOrchestratorService);
  private readonly projectionOrchestratorService = inject(OfficialPlannedPlantationProjectionPlanningOrchestratorService);

  service = {
    create: (input: OfficialPlannedPlantationCreateDto) => this.planningOrchestratorService.create(input),
    update: (id: number, input: OfficialPlannedPlantationUpdateDto) => this.planningOrchestratorService.update(id, input),
    deleteByIds: ids => this.guardedDeletion.deleteByIds('official-planned-plantations', ids),
    getList: (input: GetOfficialPlannedPlantationProjectionListInputDto) =>
      this.projectionOrchestratorService.getList(input),
    getDownloadToken: () => this.projectionOrchestratorService.getDownloadToken(),
    getListAsExcelFile: (input: OfficialPlannedPlantationProjectionExcelDownloadDto) =>
      this.projectionOrchestratorService.getListAsExcelFile(input),
    projectionConsistency: this.createProjectionConsistency(
      this.projectionOrchestratorService,
      'officialPlannedPlantationId',
    ),
  };
  config = OFFICIALPLANNEDPLANTATION_CONFIG;
  fields = OFFICIALPLANNEDPLANTATION_FIELDS;

  protected override prepareCreateDto(data: any): OfficialPlannedPlantationCreateDto {
    return {
      officialPlannedPlantationHeaderId: data.officialPlannedPlantationHeaderId,
      standLocationId: data.standLocationId,
      reasonId: data.reasonId,
    };
  }

  protected prepareUpdateDto(data: any, selected: OfficialPlannedPlantationProjectionDto): OfficialPlannedPlantationUpdateDto {
    return {
      officialPlannedPlantationHeaderId: data.officialPlannedPlantationHeaderId,
      standLocationId: data.standLocationId,
      reasonId: data.reasonId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'OfficialPlannedPlantation';
  }
}
